import memoize from 'memoize';

import { getToken } from './tokenService';
import { axiosRefTokenInst } from './axiosService';
import { updateToken } from './tokenService';
import { REFRESH_TOKEN, TOKEN } from '../common/constants/localStorage';
import { isImpersonationTab } from './impersonationSession';

const refreshTokenFn = async () => {
    // an impersonation token comes without a refresh token: its tab never calls the refresh endpoint
    if (isImpersonationTab()) {
        return undefined;
    }

    const response = await axiosRefTokenInst.post('/auth-consumers/refresh-token', {
        refreshToken: getToken(REFRESH_TOKEN),
    });

    if (response) {
        updateToken(TOKEN, response.data.accessToken);
        updateToken(REFRESH_TOKEN, response.data.refreshToken);
    }
    return response?.data;
};

const maxAge = 10000;

export const memoizedRefreshToken = memoize(refreshTokenFn, {
    maxAge,
});
